<template>
	<!-- 就诊流程_申请单录入 -->
	<div class="diagnosis-add-page">
		<div class="diagnosis-add-page-content">
			<div class="title">{{pageTitle}}</div>
			<div class="content">
				<a-form>
					<a-row class="input-row">
						<a-col :span="24">
							<a-form-item
									:validate-status="isSubmit&&!formData.hosBarCode?'error':''"
									:help="isSubmit&&!formData.hosBarCode?'请输入协作组条码':''"
							>
								<div class="name hospital-required">协作组条码</div>
								<div>
									<a-input v-model="formData.hosBarCode" placeholder="输入协作组条码"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!formData.deptId?'error':''"
									:help="isSubmit&&!formData.deptId?'请选择测序中心':''"
							>
								<div class="name hospital-required">测序中心</div>
								<div>
									<a-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											:disabled="sequencingStatus"
											style="width:100%;"
											v-model="formData.deptId"
											placeholder="请选择测序中心"
									>
										<a-select-option
												:key="item.deptId"
												v-for="item in sequencingData"
												:value="item.deptId+''"
										>{{item.deptName}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!formData.barCode?'error':''"
									:help="isSubmit&&!formData.barCode?'请输入测序中心条码':''"
							>
								<div class="name hospital-required">测序中心条码</div>
								<div>
									<a-input v-model="formData.barCode" placeholder="输入测序中心条码"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!formData.patientName?'error':''"
									:help="isSubmit&&!formData.patientName?'请输入姓名':''"
							>
								<div class="name hospital-required">姓名</div>
								<div>
									<a-input v-model="formData.patientName" placeholder="输入姓名"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!formData.sexName?'error':''"
									:help="isSubmit&&!formData.sexName?'请选择性别':''"
							>
								<div class="name hospital-required">性别</div>
								<div>
									<a-select :getPopupContainer="triggerNode => triggerNode.parentNode"
									          style="width:100%;" v-model="formData.sexName" placeholder="请选择">
										<a-select-option value="男">男</a-select-option>
										<a-select-option value="女">女</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<!-- :validate-status="isSubmit&&!formData.patientCardNo?'error':''"
							:help="isSubmit&&!formData.patientCardNo?'请输入身份证号':''"-->
							<a-form-item
									:validate-status="isSubmit&&!isCard()?'error':''"
									:help="isSubmit&&!isCard()?'请输入正确的身份证号':''"
							>
								<div class="name">身份证号</div>
								<div>
									<a-input v-model="formData.patientCardNo" :disabled="!editData?false:true"
									         placeholder="输入身份证号"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!formData.hospitalId?'error':''"
									:help="isSubmit&&!formData.hospitalId?'请选择就诊医院':''"
							>
								<div class="name hospital-required">就诊医院</div>
								<div>
									<a-select :getPopupContainer="triggerNode => triggerNode.parentNode"
									          style="width:100%;" v-model="formData.hospitalId" placeholder="请选择就诊医院">
										<a-select-option
												:key="item.deptId+''"
												v-for="item in hospitalData"
												:value="item.deptId+''"
										>{{item.deptName}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name">门诊号</div>
								<div>
									<a-input v-model="formData.patientNo" placeholder="输入门诊号"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item>
								<div class="name">就诊日期</div>
								<div>
									<a-date-picker
											:getCalendarContainer="triggerNode => triggerNode.parentNode"
											style="width:100%;"
											placeholder="选择就诊日期"
											v-model="formData.seeDoctorTime"
									/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!isOkCollectionTime(formData.sampleCollectionTime,formData.ageBirthDay)?'error':''"
									:help="isSubmit&&!isOkCollectionTime(formData.sampleCollectionTime,formData.ageBirthDay)?'采样日期不得大于当前日期和小于出生日期':''"
							>
								<div class="name">采样日期</div>
								<div>
									<a-date-picker
											:getCalendarContainer="triggerNode => triggerNode.parentNode"
											style="width:100%;"
											placeholder="选择采样日期"
											v-model="formData.sampleCollectionTime"
									/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!isOkDate(formData.ageBirthDay)?'error':''"
									:help="isSubmit&&!isOkDate(formData.ageBirthDay)?'出生日期不得大于当前日期':''"
							>
								<div class="name">出生日期</div>
								<div>
									<a-date-picker
											:getCalendarContainer="triggerNode => triggerNode.parentNode"
											style="width:100%;"
											placeholder="选择出生日期"
											v-model="formData.ageBirthDay"
									/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.applyItemName?'error':''"
							             :help="isSubmit&&!formData.applyItemName?'请选择检测项目':''">
								<div class="name hospital-required">检测项目</div>
								<div>
									<a-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											style="width:100%;"
											v-model="formData.applyItemName"
											placeholder="请选择检测项目"
									>
										<a-select-option
												v-for="item in applyItems"
												:key="item.dictKey"
												:value="item.dictKey+''"
										>{{item.dictValue}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&formData.scanFlag==undefined?'error':''"
									:help="isSubmit&&formData.scanFlag==undefined?'请选择FQ录入方式':''"
							>
								<div class="name hospital-required">FQ录入方式
									<a-tooltip placement="topLeft"
									           title="选择“平台录入”代表本系统浏览器上传fq；选择“云平台同步”代表从云平台同步fq，需确认fq在云平台路径存在">
										<a-icon type="question-circle"/>
									</a-tooltip>
								</div>
								<div>
									<a-select :getPopupContainer="triggerNode => triggerNode.parentNode"
									          style="width:100%;"
									          v-model="formData.scanFlag"
									          placeholder="请选择">
										<a-select-option :value="0">平台录入</a-select-option>
										<a-select-option :value="1">云平台同步</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name">样本类型</div>
								<div>
									<a-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											style="width:100%;"
											v-model="formData.sampleTypeName"
											placeholder="请选择样本类型"
									>
										<a-select-option
												v-for="item in sampleTypes"
												:key="item.dictKey"
												:value="item.dictKey+''"
										>{{item.dictValue}}
										</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item
									:validate-status="isSubmit&&!isOkNum(formData.sampleAmount)?'error':''"
									:help="isSubmit&&!isOkNum(formData.sampleAmount)?'样本量最多保留两位小数':''"
							>
								<div class="name">样本量（ml）</div>
								<div>
									<a-input v-model="formData.sampleAmount" placeholder="输入样本量（ml）"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name">临床诊断</div>
								<div>
									<a-input v-model="formData.clinicalDiagnosis" placeholder="输入临床诊断"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">

						</a-col>
					</a-row>
				</a-form>
				<div class="footer">
					<a-button :loading="isHttpSubmit" @click="submit()" type="primary">确定</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import moment from "moment";
  import {regAll} from "../../common/validate";

  export default {
    props: {
      editData: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        isSubmit: false,
        isHttpSubmit: false,
        formData: {
          hosBarCode: "",
          deptId: null,
          barCode: "",
          patientName: "",
          patientCardNo: "",
          patientNo: "",
          sampleAmount: "",
          applyItemName: undefined,
          groupName: "",
          ageBirthDay: null,
          sampleCollectionTime: null,
          seeDoctorTime: null,
          sampleTypeName: undefined,
          hospitalId: undefined,
          scanFlag: undefined,
        },
        hospitalData: [],
        sampleTypes: [],
        sequencingData: [],
        sequencingStatus: false,
        applyItems: [],
        isEdit: false,
        pageTitle: "就诊流程 _申请单录入"
      };
    },
    mounted() {
      if (this.editData) {
        this.pageTitle = "就诊流程 _申请单编辑";
        this.isEdit = true;
        this.formData = Object.assign(this.formData, this.editData);
        this.formData.deptId = this.formData.deptId + "";
        if (this.editData.ageBirthDay) {
          this.formData.ageBirthDay = moment(
            this.editData.ageBirthDay,
            "YYYY-MM-DD"
          );
        }
        if (this.editData.sampleCollectionTime) {
          this.formData.sampleCollectionTime = moment(
            this.editData.sampleCollectionTime,
            "YYYY-MM-DD"
          );
        }
      } else {
        this.pageTitle = "就诊流程 _申请单录入";
        this.formData = Object.assign(
          {},
          {
            hosBarCode: "",
            barCode: "",
            patientName: "",
            patientCardNo: "",
            hospitalId: undefined,
          }
        );
      }

      this.getDirt("sampleType").then(data => {
        this.sampleTypes = data.rows;
      });
      this.getDirt("applyItem").then(data => {
        this.applyItems = data.rows;
      });
      this.gethospital();
    },
    methods: {
      isOkNum(num) {
        if (this.formData.sampleAmount) {
          if (!regAll.regNum2.test(this.formData.sampleAmount)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      isCard() {
        if (this.formData.patientCardNo) {
          if (!regAll.regCardNo.test(this.formData.patientCardNo)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      isOkDate(date) {
        if (date) {
          let currentDate = new Date(date.format("YYYY-MM-DD")).getTime();
          return (
            currentDate < new Date().getTime() ||
            currentDate == new Date().getTime()
          );
        } else {
          return true;
        }
      },
      isOkCollectionTime(date, ageBirthDay) {
        if (date) {
          let currentDate = new Date(date.format("YYYY-MM-DD")).getTime();
          if (ageBirthDay) {
            let ageBirthDate = new Date(
              ageBirthDay.format("YYYY-MM-DD")
            ).getTime();
            return (
              (currentDate < new Date().getTime() ||
                currentDate == new Date().getTime()) &&
              (currentDate > ageBirthDate || currentDate == ageBirthDate)
            );
          } else {
            return (
              currentDate < new Date().getTime() ||
              currentDate == new Date().getTime()
            );
          }
        } else {
          return true;
        }
      },
      submit() {
        this.isSubmit = true;
        this.$nextTick(() => {
          let submitData = {};
          const isPass =
            document.querySelectorAll(".ant-form-explain").length == 0;
          if (isPass) {
            submitData = Object.assign({}, this.formData);
            if (submitData.ageBirthDay) {
              submitData.ageBirthDay = this.formData.ageBirthDay.format(
                "YYYY-MM-DD"
              );
            }
            if (submitData.sampleCollectionTime) {
              submitData.sampleCollectionTime = this.formData.sampleCollectionTime.format(
                "YYYY-MM-DD"
              );
            }
            this.isHttpSubmit = true;
            if (this.isEdit) {
              this.$put("patientitem/patientItem", submitData, {
                "Content-Type": "application/json"
              }).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("就诊流程修改成功!");
                    this.$emit("close");
                  } else {
                    this.isHttpSubmit = false;
                    this.$message.error(res.data.message);
                  }
                },
                error => {
                  this.isHttpSubmit = false;
                  // this.$message.error("就诊流程修改失败!");
                }
              );
            } else {
              this.$post("patientitem/patientItem/bacth", [submitData], {
                "Content-Type": "application/json"
              }).then(
                res => {
                  if (res.data.code == 1) {
                    this.$message.success("就诊流程 _申请单录入成功!");
                    this.$emit("close");
                  } else {
                    this.isHttpSubmit = false;
                    this.$message.error(res.data.message);
                  }
                },
                error => {
                  this.isHttpSubmit = false;
                  this.$message.error("就诊流程 _申请单录入失败!");
                }
              );
            }
          }
        });
      },
      gethospital() {
        this.$get("dept/findDeptTreeList", {
          pageSize: 10000,
          deptType: 1
        }).then(res => {
          this.hospitalData = res.data.data[0].children;
        });
        this.$get("dept/findDeptTreeList", {
          pageSize: 10000,
          deptType: 2
        }).then(res => {
          const userInfo = this.$db.get("userInfo");
          this.sequencingData = res.data.data[0].children;
          if (!this.editData) {
            if (userInfo.deptId == null) {
              this.sequencingStatus = false;
            } else {
              this.sequencingData.forEach(item => {
                if (item.deptId == userInfo.deptId) {
                  this.formData.deptId = userInfo.deptId + "";
                  this.sequencingStatus = true;
                }
              });
            }
          } else {
            if (userInfo.deptId == null) {
              this.sequencingStatus = false;
            } else {
              this.sequencingData.forEach(item => {
                if (item.deptId == userInfo.deptId) {
                  this.sequencingStatus = true;
                }
              });
            }
          }
        });
      },
      getList() {
        this.$get("/uploadfq/uploadFq/getFqList", {
          bid: "1"
        }).then(res => {
        });
      },
      getDirt(dictType) {
        return new Promise((resolve, reject) => {
          this.$get("info/commonDict", {
            dictType: dictType,
            pageSize: 10000
          }).then(
            res => {
              resolve(res.data.data);
            },
            err => {
              reject(err);
            }
          );
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.diagnosis-add-page {
		width: 100%;
		height: 100%;
		background: #fff;
		overflow: auto;
		.ant-form-item {
			height: 85px;
			margin-bottom: 0px;
		}
		.diagnosis-add-page-content {
			width: 682px;
			margin: 80px auto 40px;
		}
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			margin-bottom: 50px;
		}
		.content {
			padding: 45px;
			border: 1px solid rgba(243, 245, 247, 1);
			.name {
				font-size: 13px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(164, 164, 164, 1);
				line-height: 14px;
				margin-bottom: 10px;
			}
			.input-row {
				.left {
					padding-right: 26px;
				}
				.right {
					padding-left: 26px;
				}
			}
		}
		.footer {
			.ant-btn {
				width: 100%;
			}
		}
	}
</style>